import { useDebugValue, useEffect, useMemo, useState } from "react";
import { RestS } from "../../../rest/rest-service";
import styles from './PcHome.module.scss';
import { MdCheckCircle as CheckCircleIcon } from 'react-icons/md'
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { HiArrowNarrowRight as RightArrowIcon } from 'react-icons/hi';
import PcColdStateImg from '../../../assets/images/profitabilityCalculator/profitability calculator.svg';
import PcColdStateImgNew from '../../../assets/images/profitabilityCalculator/pcLandingImg.svg'
import PcColdStateBlur from '../../../assets/images/profitabilityCalculator/coldStateBlur.svg';
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import { IpNames, PcColdStates, PcJourneyStatus, ProductFetchingProgress } from "../../../interfaces/interfaces";
import { useAppDispatch, useAppSelector } from "../../../redux/reduxHooks";
import { ColdStateType } from "../../DecisionHub/interfaces";
import { Navigate, useNavigate } from "react-router";
import { setRefreshPcHome } from "../../../redux/financeStatement/financeStatement";
import { getLocalUser } from "../../../components/functions/utilities";
import { OverlayTrigger } from "react-bootstrap";
import { RenderAccessToolTip } from "../../../components/common/RenderTooltip";
import usePageTitle from "../../../components/Hooks/usePageTitle";
import { MdLockOutline as LockIcon } from "react-icons/md";

const helpPoints = [
    "Set up your first P&L in just 10 minutes.",
    "Update real costs monthly—takes just 2 minutes.",
    "Receive your P&L directly via WhatsApp."
];


const BtnText = {
    [PcColdStates.salesChannelDataFetching]: "Fetching Data",
    [PcColdStates.journeyInProgress]: "In Progress",
}

const PcHome = () => {
    const [pcColdState, setPcColdState] = useState(null);
    const [allowGetStarted, setAllowGetStarted] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [getStartedLoading, setGetStartedLoading] = useState(false);
    const [accessUsers, setAccessUsers] = useState([]);

    const { dfProgress } = useAppSelector((state) => state.dataFetchingProgress);

    const { integrationPartners } = useAppSelector((state) => state.config);
    const { connectionStatus } = useAppSelector((state) => state.connections);
    const [journeyData, setJorneyData] = useState(null)

    const { refreshPcHome } = useAppSelector(state => state.financeStatement)
    const dispatch = useAppDispatch();
    const currentUser = getLocalUser();
    const [showFs, setShowFs] = useState(false);
    const pageTitle = usePageTitle('P&L Tracker | Merito');



    const ipConfigs = useMemo(() => {
        if (integrationPartners != undefined) {
            let configObj = {};
            const connectionStatusSet = new Set(connectionStatus);

            for (const ip of Object.values(integrationPartners)) {
                // console.log('ip', ip)
                const logo = ip['logo'];
                const ipId = ip["_id"]
                // if(connectionStatusSet.has(ip['_id'])) {
                configObj[ip['companyName']] = {
                    connectionStatus: connectionStatusSet.has(ipId) ? true : false,
                    logo
                };
                // } 
            }
            return configObj;
        } else {
            return {};
        }
    }, [integrationPartners, connectionStatus]);

    const checkGetStarted = async () => {
        try {
            const { allowGetStarted, coldState, isFirstUser, redirectToHome, success, journeyData, allUserAccess, showFs } = await RestS.checkPcGetStarted();
            setAllowGetStarted(allowGetStarted);
            setPcColdState(coldState);
            setJorneyData(journeyData);
            setShowFs(showFs)
            if (allUserAccess && allUserAccess.length) {
                setAccessUsers(allUserAccess)
            }
            return { allowGetStarted, coldState, isFirstUser, redirectToHome, success };
        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        // if (update?.updateAvailable) {
        const bodyElement = document.getElementsByTagName("body")[0];
        bodyElement.style.overflowY = "hidden";
        const pageIndexLayout: any = document.getElementById("page_body");
        if (pageIndexLayout) {
            // pageIndexLayout.style.overflowY = "hidden";
            pageIndexLayout.style.padding = "0rem";
        }

        return () => {
            const bodyElement = document.getElementsByTagName("body")[0];
            const pageIndexLayout: any = document.getElementById("page_body");
            if (pageIndexLayout) {
                pageIndexLayout.style.overflowY = "scroll";
                pageIndexLayout.style.padding = "1rem 1.5rem 2rem 1.5rem";
            }
            pageTitle('')
        };
        // }
    }, []);

    useEffect(() => {
        if (refreshPcHome) {
            checkGetStarted();
            dispatch(setRefreshPcHome(false));
        }
    }, [refreshPcHome])

    useEffect(() => {
        (async () => {
            // setLoading(true);
            await checkGetStarted();
            setLoading(false);
        })()
    }, [])

    useEffect(() => {
        checkGetStarted();
    }, [dfProgress]);


    const handleGetStarted = async () => {
        try {
            setGetStartedLoading(true);
            const { allowGetStarted, coldState, isFirstUser, redirectToHome, success } = await checkGetStarted();

            // return;
            if (allowGetStarted && isFirstUser) {
                let bodyData = {
                    journeyStatus: PcJourneyStatus.inProgress
                }
                const journeyResponse: any = await RestS.updatePcJourney(bodyData);
                const { isInActive, isInProgress, isUpdateAvailable } = await RestS.checkJourneyRouteAccess();
                if (journeyResponse?.success) {
                    // if (isInProgress || isUpdateAvailable || isInActive) {
                    //     navigate('/profitability-calculator/edit/access');
                    // } else {
                    navigate('/pnltracker/edit/access')
                    // }

                }
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setGetStartedLoading(false)
        }
    }

    const journeyDataText = useMemo(() => {
        if (journeyData) {
            const userName = journeyData?.name.toString().trim();
            return <>{`${userName} is working on your brand’s P&L.`} <br />  {`You can view it once they’ve completed.`}</>
        } else {
            return null;
        }

    }, [journeyData]);


    const formattedAccessText = useMemo(() => {
        if (accessUsers && accessUsers.length) {
            const firstUser = accessUsers[0];
            const newAccessUsers = accessUsers.slice(1).map((item) => item.name.toString().trim());
            return {
                firstUser,
                remainingUsers: newAccessUsers,
                remainingUsersText: newAccessUsers.length ? newAccessUsers.length == 1 ?
                    <>
                        {`,`}<br />  {`or `}
                        <OverlayTrigger placement="right" overlay={(props) => RenderAccessToolTip(props, newAccessUsers)}>
                            <span className={styles.accessHover}> 1 other.</span>
                        </OverlayTrigger>
                    </>
                    :
                    <>
                        {`,`}<br />  {`or `}
                        <OverlayTrigger placement="right" overlay={(props) => RenderAccessToolTip(props, newAccessUsers)}>
                            <span className={styles.accessHover}> {newAccessUsers.length} others.</span>
                        </OverlayTrigger>

                    </>
                    : ''
            }
        } else {
            return null;
        }
    }, [accessUsers]);

    // console.log('formattedAccessText', formattedAccessText);


    return (
        <div className={styles.pcRootContainer}>
            {loading ?
                <div className={styles.loadingContainer}>
                    <CircularLoader />
                </div>
                : showFs ?
                    <Navigate to="/pnltracker/statement" replace />
                    : <>
                        {pcColdState == PcColdStates.accessDenied ?
                            <div className={styles.accessDeniedMainContainer}>
                                <div className={styles.topContainer}>
                                    <div className={styles.iconContainer}>
                                        <LockIcon />
                                    </div>
                                    <div className={styles.titleContainer}>
                                        Access Required!
                                    </div>
                                </div>
                                <div className={styles.accessDeniedColdState}>
                                    {`You do not have access to this section.`}
                                    <br />
                                    <br />
                                    {formattedAccessText ?
                                        <>
                                            {`You can request access from ${formattedAccessText.firstUser?.name}`}
                                            {formattedAccessText.remainingUsers && formattedAccessText.remainingUsers.length ?
                                                <>
                                                    {formattedAccessText?.remainingUsersText}
                                                </>
                                                : null}
                                        </> : null
                                    }
                                </div>

                            </div>

                            :
                            <>
                                <div className={styles.leftContainer}>
                                    <div className={styles.hoomRootContainer}>
                                        <div className={styles.title}>
                                            Track your Brand's Profitability
                                        </div>
                                        <div className={styles.subTitle}>
                                            Study your unit economics with an automated P&L <br /> that consolidates data across channels
                                            {/* <br />and Net Cash statement for your brand. */}
                                        </div>

                                        <div className={styles.helpContainer}>
                                            <div className={styles.helpTitle}>
                                                How to use the P&L Tracker?
                                            </div>
                                            <ul className={styles.listContainer}>
                                                {helpPoints.map((item, index) => {
                                                    return (
                                                        <li className={styles.listItem}>
                                                            <CheckCircleIcon />
                                                            <p className={styles.listItemText}>{item}</p>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                        {pcColdState != PcColdStates.connectSalesChannel && pcColdState != PcColdStates.accessDenied ? <div>
                                            <MeritoButton onClick={handleGetStarted} 
                                                disabled={pcColdState == PcColdStates.journeyInProgress || pcColdState == PcColdStates.salesChannelDataFetching ? true : false} 
                                                showLoadingWithText={true} 
                                                isIconToRight={true} size="lg" 
                                                btnText={BtnText[pcColdState] != undefined ? BtnText[pcColdState] : journeyData?.status == "in_progress" ? "Resume" : "Get Started"} 
                                                loading={pcColdState == PcColdStates.journeyInProgress || pcColdState == PcColdStates.salesChannelDataFetching || getStartedLoading ? true : false} 
                                                icon={<RightArrowIcon />} 
                                                type="primary-1" />
                                        </div> : null}
                                    </div>

                                    {pcColdState == PcColdStates.connectSalesChannel ?
                                        <div className={styles.salesColdState}>
                                            <div className={styles.channelContainer}>
                                                <div className={styles.iconContainer}>
                                                    <img src={ipConfigs && ipConfigs[IpNames.shopify] ? ipConfigs[IpNames.shopify]['logo'] : ''} alt="" />
                                                </div>
                                                <div className={styles.divider}></div>
                                                <div className={styles.iconContainer}>
                                                    <img src={ipConfigs && ipConfigs[IpNames.amazonSellerCentral] ? ipConfigs[IpNames.amazonSellerCentral]['logo'] : ''} alt="" />
                                                </div>
                                                <div className={styles.divider}></div>
                                                <div className={styles.iconContainer}>
                                                    <img src={ipConfigs && ipConfigs[IpNames.amazonVendorCentral] ? ipConfigs[IpNames.amazonVendorCentral]['logo'] : ''} alt="" />
                                                </div>
                                                <div className={styles.divider}></div>
                                                {/* <div className={styles.iconContainer}>
                                                    <img src={ipConfigs && ipConfigs[IpNames.flipkartSeller] ? ipConfigs[IpNames.flipkartSeller]['logo'] : ''} alt="" />
                                                </div> */}
                                            </div>
                                            <div className={styles.salesSubText}>
                                                Connect at least one sales channel to view <br /> your brand’s P&L.
                                            </div>
                                            <div>
                                                <MeritoButton onClick={() =>
                                                    navigate("/WorkspaceStore?connectionHub=true", {
                                                        state: { from: "GoalsHub" },
                                                    })
                                                } size="lg" btnText={"Connect Account"} type="primary-1" />
                                            </div>
                                        </div> : null}
                                    {pcColdState == PcColdStates.journeyInProgress && journeyDataText ?
                                        <div className={styles.journeyProgressColdState}>
                                            {journeyDataText}
                                        </div> : null}


                                </div>
                                <div className={styles.rightContainer}>
                                    <div className={styles.imgContainer}>
                                        <img className={styles.coldStateImg} src={PcColdStateImgNew} />
                                        <img className={styles.blurImg} src={PcColdStateBlur} />
                                    </div>
                                </div>
                            </>
                        }

                    </>
            }
        </div>
    );
}

export default PcHome;